import { format, isValid, parse } from 'date-fns';
import { IDropdownItemWithHint } from '../../../ui';
import { createTime, getTimeInMinutes } from '../../../utils/dateTime';

export interface ITimeOption extends IDropdownItemWithHint {
	value: string;
	stringValue: string;
	timeInMinutes: number;
	hasSecondaryStyle?: boolean;
}

export type MaybeTimeOption = ITimeOption | null;

export function createTimeOption(value: string): ITimeOption {
	const parsedValue = parseValue(value);

	if (!parsedValue) {
		throw new Error(`Invalid time value: '${value}'`);
	}

	return {
		value,
		timeInMinutes: getTimeInMinutes(createTime(parsedValue)),
		stringValue: formatTime(parsedValue),
		hasSecondaryStyle: hasSecondaryStyle(parsedValue),
	};
}

function hasSecondaryStyle(value: Date) {
	return value.getHours() >= 12;
}

export function parseValue(value: string): Date | undefined {
	const date = parse(value, 'HH:mm', new Date());

	return isValid(date) ? date : undefined;
}

function formatTime(date: Date) {
	return format(date, 'h:mm a');
}
